import React, { useState, useEffect } from "react";

const BrowserCheck = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Check browser compatibility
    const checkBrowser = () => {
      const ua = navigator.userAgent;
      
      // Check for IE (any version)
      if (ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1) {
        return false;
      }
      
      // Check for very old browsers by checking for basic features
      const isModern = 
        typeof Promise !== 'undefined' &&
        typeof fetch !== 'undefined' &&
        typeof Symbol !== 'undefined' &&
        typeof WeakMap !== 'undefined';
      
      return isModern;
    };

    if (!checkBrowser()) {
      setShowWarning(true);
    }
  }, []);

  if (!showWarning) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-900/95 backdrop-blur border-b border-yellow-700/50">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 text-sm text-yellow-100">
            <span className="text-xl">⚠️</span>
            <p>
              <strong>Outdated browser detected.</strong> For the best experience, please use a modern browser such as Chrome, Edge, Safari, or Firefox.
            </p>
          </div>
          <button
            onClick={() => setShowWarning(false)}
            className="flex-shrink-0 text-yellow-100 hover:text-white text-xl leading-none"
            aria-label="Dismiss warning"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrowserCheck;
